// Performance product strings are stored without the colon — a colon in a product
// key or label makes the chart product lookup fall through to Oil — so the ratio is
// put back at render time only.
// The data table names the 6:1 products bare, without the "Wellhead" the chart side uses.
const RATIO_DISPLAY_NAMES: Record<string, string> = {
  BOE: "BOE 6:1",
  "BOE 20": "BOE 20:1",
  "BOE 30": "BOE 30:1",
  "Sales BOE": "Sales BOE 6:1",
  "Sales BOE 20": "Sales BOE 20:1",
  "Sales BOE 30": "Sales BOE 30:1"
};

/** Same product with every space, comma and plus taken out. */
const compactProductKey = (product: string): string =>
  product?.replace(/[ ,+]+/g, "") ?? product;

// Keyed on both the stored form and the space-free one: some data-fetch paths strip
// the spaces out of the product before it reaches a label builder, and a miss there
// shows the operator a name the data table does not use.
const PERFORMANCE_RATIO_DISPLAY_NAMES: Record<string, string> = Object.fromEntries(
  Object.entries(RATIO_DISPLAY_NAMES).flatMap(([key, name]) => [
    [key, name],
    [compactProductKey(key), name]
  ])
);

/**
 * Add the ratio back to a stored performance product name. Leaves every other
 * product untouched.
 *
 * @param {string} product the stored product name
 * @returns {string} the name to display
 */
export const getPerformanceRatioDisplayName = (product: string): string =>
  Object.hasOwn(PERFORMANCE_RATIO_DISPLAY_NAMES, product ?? "")
    ? PERFORMANCE_RATIO_DISPLAY_NAMES[product]
    : product;

/**
 * Get the display name for a product
 *
 * @param {string} product the product
 * @returns {string} The display name for the product
 */
const getProductDisplayName = (product: string): string => {
  if (product?.toLocaleLowerCase() === "oil") {
    return "Oil + Cond";
  }
  return getPerformanceRatioDisplayName(product) ?? "";
};

export default getProductDisplayName;
